/** Map of all resolved path titles */
export const INSIGHTS_ROUTING_TITLE_MAP = {
    'error-insights': 'ERROR_INSIGHTS_VIEW.TITLE',
};
